import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { changeStatusOrCostPerClick } from "../../redux/actions/bidding";
import Button from "../shared/button";
import WalletInput from "../shared/form/price-input";
import "./bidding-styles.scss";

interface Props {
  doctorId: number;
  costPerClick: number;
  status: boolean;
  max: number;
  min: number;
}

const BiddingPrice = ({ doctorId, costPerClick, status, max, min }: Props) => {
  const dispatch = useDispatch();

  const [price, setPrice] = useState(costPerClick);
  const [basePrice, setBasePrice] = useState(costPerClick >= min ? costPerClick : min - 50);
  const [changePrice, setChangePrice] = useState(false);

  const onSubmit = async () => {
    await dispatch(changeStatusOrCostPerClick(doctorId, status, price));

    setChangePrice(!changePrice);
  };
  return (
    <div className="mt-6 text-sm font-medium ">
      <div className="flex justify-between">
        <p>قیمت هر بازدید</p>
        {!changePrice && (
          <p
            className="cursor-pointer text-pkc-dark-blue"
            onClick={() => setChangePrice(!changePrice)}
            id="changePriceOdEachObserve"
          >
            تغییر قیمت
          </p>
        )}
      </div>

      <div className="wallet_price">
        <WalletInput value={price.toLocaleString()} background={changePrice && "white"} readOnly={true} />
        {changePrice && (
          <>
            <i
              className="far fa-caret-up upIcon"
              onClick={() => {
                basePrice + 50 <= max && setPrice(basePrice + 50);
                basePrice + 50 <= max && setBasePrice(basePrice + 50);
              }}
              id="decreaseBudge"
            ></i>
            <i
              className="far fa-caret-down downIcon"
              onClick={() => {
                basePrice - 50 >= min && setPrice(basePrice - 50);
                basePrice - 50 >= min && setBasePrice(basePrice - 50);
              }}
              id="reduceBudge"
            ></i>
          </>
        )}
      </div>

      {changePrice && (
        <div className="grid grid-cols-2 gap-2 md:float-left md:w-1/2">
          <Button onClick={onSubmit}>ذخیره تغییر قیمت</Button>
          <Button
            className="!border-1 !border-pkc-red !text-pkc-red"
            variant="outline"
            onClick={() => {
              setChangePrice(!changePrice);
              setPrice(costPerClick!);
              setBasePrice(costPerClick >= min ? costPerClick : min - 50);
            }}
          >
            انصراف
          </Button>
        </div>
      )}
    </div>
  );
};

export default BiddingPrice;
